import {
  AppBar,
  IconButton,
  Stack,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import MenuIcon from '@mui/icons-material/Menu';
import { memo } from 'react';
import { useHeader } from './useHeader';
import UserMenu from './UserMenu';
import { useAtomValue } from 'jotai';
import userAtom from '@/store/auth/user';

const Header = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const {
    title,
    anchorEl,
    isSignOutInProgress,
    handleClickAccount,
    handleCloseAccount,
    handleClickLogout,
    handleClickMenu,
  } = useHeader();
  const user = useAtomValue(userAtom);

  return (
    <AppBar position="sticky">
      <Toolbar variant={isMobile ? 'dense' : 'regular'}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
          <Stack direction="row" alignItems="center" gap={1}>
            <IconButton
              sx={{ display: { xs: 'inline-flex', sm: 'none' } }}
              aria-label="メニュー"
              onClick={handleClickMenu}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              variant={'h6'}
              color="inherit"
              fontSize={{ xs: 18, sm: 24 }}
              fontWeight="bold"
            >
              {title}
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" spacing={1}>
            <IconButton onClick={handleClickAccount} aria-label="アカウント">
              <AccountCircleOutlinedIcon />
            </IconButton>
            <UserMenu
              anchorEl={anchorEl}
              user={user}
              isLogoutButtonDisabled={isSignOutInProgress}
              onClose={handleCloseAccount}
              onClickLogout={handleClickLogout}
            />
          </Stack>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default memo(Header);
